import { PagedList } from "@shared/list/paged-list";
import { BaseApiResponse, ClientType, PaginationListRequest } from "./common";
import { EInvoiceBankAccountDto } from "./e-invoice-bank-account";
import { EInvoiceClientDto } from "./e-invoice-client";
import {
  LatePaymentInterestType,
  PaymentMethodType,
  PaymentTermsType,
} from "./e-invoice-preference";
import {
  EInvoiceDeliveryDetailsDto,
  EInvoiceType,
  InvoiceVatPaymentType,
  ListInvoiceItemResponse,
  SaveDeliveryDetailsRequest,
} from "./e-invoice";
import {
  EInvoiceAssuranceType,
  EInvoiceCompanyModel,
  SaveTaxRepresentativeRequest,
} from "./e-invoice-company";
import {
  AddInvoiceItemRequest,
  EInvoiceItemDto,
  EditInvoiceItemRequest,
} from "./e-invoice-item";
import { EInvoiceTvaAggregation } from "./e-invoice-tva";
import { EInvoiceDiscountDto } from "./e-invoice-discount/e-invoice-discount.model";

export class EInvoiceDto {
  Id: number;
  UserId: number;
  ClientId: number | null;
  PreferenceId: number;
  BankAccountId: number | null;
  FileGuid: string | null;
  FileName: string | null;
  Status: InvoiceStatus | null;
  PublishDate: string | null;
  CreatedDate: string;
  IssueDate: string;
  DeliveryDate: string | null;
  DueDate: string | null;
  Code: string;
  TotalHt: number;
  TotalTtc: number;
  TotalTva: number;
  DuePayableAmount: number;
  LineTotalAmount: number;
  Currency: string;
  IsOutOfTvaScope: boolean;
  IsCustomDelivery: boolean;
  Type: EInvoiceType;
  ParentInvoiceId: number | null;
  ParentInvoiceCode: string | null;
  TotalPrepaidAmountTtc: number;
  DeliveryDetails: EInvoiceDeliveryDetailsDto | null;
  User: EInvoiceUserDto;
  BankAccount: EInvoiceBankAccountDto;
  Client: EInvoiceClientDto;
  Preference: EInvoicePreferenceDto;
  Company: EInvoiceCompanyModel;
  Items: EInvoiceItemDto[];
  Discount: EInvoiceDiscountDto | null;
  TvaAggregationList: EInvoiceTvaAggregation[];
  PurchaseOrderCode: string | null;
  VatPaymentType: InvoiceVatPaymentType;
}

export interface EInvoiceUserDto {
  Id: number;
  Type: ClientType;
  Name: string;
  Email: string;
  Address: string;
  PostCode: string;
  City: string;
  Country: string;
  Siret: string | null;
  TvaNumber: string | null;
}

export class EInvoicePreferenceDto {
  Id: number;
  Currency: number | null;
  PaymentTerms: PaymentTermsType | null;
  PaymentMethod: PaymentMethodType | null;
  LatePaymentInterest: LatePaymentInterestType | null;
  IntroductionText: string | null;
  ConclusionText: string | null;
  FooterText: string | null;
  CustomPaymentTermsLabel: string | null;
  CustomLatePaymentInterest: number | null;
  DisplayMessage:boolean;
}

export class ListInvoiceRequest extends PaginationListRequest {
  CompanyId: number;
  ClientSearchText: string | null;
  InvoiceCodeSearchText: string | null;
  StartDate: string | null;
  EndDate: string | null;
  Status: InvoiceStatus | null;
  Type: EInvoiceType | null;
}

export class EInvoiceListModel extends PagedList<ListInvoiceItemResponse> {
  Data: { TotalHt: number };
}

export interface ISaveInvoiceRequest {
  CompanyId: number;
  UserId: number;
  ClientId: number;
  BankAccountId: number | null;
  Currency: number;
  PaymentTerms: PaymentTermsType | null;
  PaymentMethod: PaymentMethodType | null;
  LatePaymentInterest: LatePaymentInterestType | null;
  IntroductionText: string | null;
  ConclusionText: string | null;
  FooterText: string | null;
  IssueDate: string;
  CustomDueDate: string | null;
  CustomPaymentTermsLabel: string | null;
  DeliveryDate: string | null;
  CompanyTvaNumber: string;
  IsOutOfTvaScope: boolean;
  IsJudicialLiquidation: boolean;
  IsCustomDelivery: boolean;
  DeliveryDetails: SaveDeliveryDetailsRequest | null;
  IsTaxRepresentative: boolean;
  TaxRepresentative: SaveTaxRepresentativeRequest | null;
  Type: EInvoiceType;
  ParentInvoiceId: number | null;
  AssuranceType: EInvoiceAssuranceType | null;
  AssuranceName: string | null;
  AssuranceContractIdentifier: string | null;
  AssuranceGeographicCoverage: string | null;
  DiscountPercent: number | null;
  PurchaseOrderCode: string | null;
  CustomLatePaymentInterest: number | null;
  VatPaymentType: InvoiceVatPaymentType | null;
  DisplayMessage:boolean;
  LogoUrl:string | null;
}
export class AddInvoiceRequest implements ISaveInvoiceRequest {
  CompanyId: number;
  UserId: number;
  ClientId: number;
  BankAccountId: number | null;
  Currency: number;
  PaymentTerms: PaymentTermsType | null;
  PaymentMethod: PaymentMethodType | null;
  LatePaymentInterest: LatePaymentInterestType | null;
  IntroductionText: string | null;
  ConclusionText: string | null;
  FooterText: string | null;
  IssueDate: string;
  CustomDueDate: string | null;
  CustomPaymentTermsLabel: string | null;
  DeliveryDate: string | null;
  Items: AddInvoiceItemRequest[];
  CompanyTvaNumber: string;
  IsOutOfTvaScope: boolean;
  IsJudicialLiquidation: boolean;
  IsCustomDelivery: boolean;
  DeliveryDetails: SaveDeliveryDetailsRequest | null;
  IsTaxRepresentative: boolean;
  TaxRepresentative: SaveTaxRepresentativeRequest | null;
  Type: EInvoiceType;
  ParentInvoiceId: number | null;
  AssuranceType: EInvoiceAssuranceType | null;
  AssuranceName: string | null;
  AssuranceContractIdentifier: string | null;
  AssuranceGeographicCoverage: string | null;
  DiscountPercent: number | null;
  PurchaseOrderCode: string | null;
  CustomLatePaymentInterest: number | null;
  VatPaymentType: InvoiceVatPaymentType | null;
  DisplayMessage:boolean;
  LogoUrl:string | null;


}
export interface AddInvoiceResponse extends BaseApiResponse<AddInvoiceError> {
  Invoice: EInvoiceDto | null;
}

export class EditInvoiceRequest implements ISaveInvoiceRequest {
  CompanyId: number;
  UserId: number;
  ClientId: number;
  BankAccountId: number | null;
  Code: string;
  Currency: number;
  PaymentTerms: PaymentTermsType | null;
  PaymentMethod: PaymentMethodType | null;
  LatePaymentInterest: LatePaymentInterestType | null;
  IntroductionText: string | null;
  ConclusionText: string | null;
  FooterText: string | null;
  DispalyMessage: boolean;
  IssueDate: string;
  CustomDueDate: string | null;
  CustomPaymentTermsLabel: string | null;
  DeliveryDate: string | null;
  EditItems: EditInvoiceItemRequest[] | null;
  NewItems: AddInvoiceItemRequest[] | null;
  CompanyTvaNumber: string;
  IsOutOfTvaScope: boolean;
  IsJudicialLiquidation: boolean;
  IsCustomDelivery: boolean;
  DeliveryDetails: SaveDeliveryDetailsRequest | null;
  IsTaxRepresentative: boolean;
  TaxRepresentative: SaveTaxRepresentativeRequest | null;
  Type: EInvoiceType;
  ParentInvoiceId: number | null;
  AssuranceType: EInvoiceAssuranceType | null;
  AssuranceName: string | null;
  AssuranceContractIdentifier: string | null;
  AssuranceGeographicCoverage: string | null;
  DiscountPercent: number | null;
  PurchaseOrderCode: string | null;
  CustomLatePaymentInterest: number | null;
  VatPaymentType: InvoiceVatPaymentType | null;
  DisplayMessage:boolean;
  LogoUrl:string | null;

}
export class ListInvoiceByEmailRequest extends ListInvoiceRequest
{
  UserEmail:string;
}

export interface EditInvoiceResponse {
  Invoice: EInvoiceDto;
  IsSuccess: boolean;
  Errors: EditInvoiceError[];
}

export interface EditInvoiceResponse {
  Invoice: EInvoiceDto;
  IsSuccess: boolean;
  Errors: EditInvoiceError[];
}

export interface DeleteInvoiceResponse
  extends BaseApiResponse<DeleteInvoiceError> {}

export interface PublishInvoiceResponse
  extends BaseApiResponse<PublishInvoiceError> {}

export interface CloneInvoiceResponse
  extends BaseApiResponse<CloneInvoiceError> {
  InvoiceId: number;
}

export enum CloneInvoiceError {
  NotFound = 1,
  UnknownError = 2,
}

export enum PublishInvoiceError {
  InvoiceNotFound = 1,
  MandatoryDataMissing = 2,
  UnknownError = 3,
}

export enum BuildInvoiceError {
  InvoiceNotFound = 1,
  UnknownError = 2,
  MandatoryDataMissing = 3,
}

export enum DeleteInvoiceError {
  NotFound = 1,
}

export enum EditInvoiceError {
  NotFound = 1,
  Dupplicate = 2,
}

export enum AddInvoiceError {
  Dupplicate = 1,
}

export enum InvoiceStatus {
  None = 0,
  Pending = 1,
  Published = 2,
}

/**
 * Sens de circulation des factures pour l'enregistrement PDP.
 * Correspond à l'enum InvoiceDirection de l'API e-Facture.
 */
export enum InvoiceDirection {
  /** Facture émise par le vendeur. */
  Seller = 1,
  /** Facture reçue par l'acheteur. */
  Buyer = 2,
  /** Émission et réception (Seller | Buyer). */
  Both = 3,
}

/**
 * Statut de la demande d'enregistrement PDP.
 * Aligné sur tCompanyRegistrationStatus (Swagger e-Facture).
 */
export enum PdpCompanyRegistrationStatus {
  Pending = 0,
  Active = 1,
  Updating = 2,
  Deleting = 3,
  Error = 4,
  Deleted = 5,
  Failed = 6,
}

export interface PdpDateOnly {
  year: number;
  month: number;
  day: number;
}

export interface PdpCompanyRegistrationCreateRequest {
  // Identification BCO
  cabinetId: number;
  // Représentant légal
  representantNom: string;
  representantPrenom: string;
  representantFonction?: string;
  representantEmail: string;
  representantTelephone?: string;
  // Société
  raisonSociale: string;
  siren: string;
  siret?: string;
  tvaIntracommunautaire?: string;
  formeJuridique?: string;
  adresseRue?: string;
  adresseCodePostal?: string;
  adresseVille?: string;
  // PDP
  invoiceDirections: InvoiceDirection;
  plateformeId: number;
  identifiantPDP: string;
  /** Date d'activation souhaitée (ISO 8601) ; optionnel, le prestataire applique sa propre valeur par défaut si absent. */
  activeFrom?: string;
  // CGU
  cguAcceptees: boolean;
  versionCgu: string;
}

export interface PdpCompanyRegistrationUpdateRequest {
  // Représentant légal
  representantNom?: string;
  representantPrenom?: string;
  representantFonction?: string;
  representantEmail?: string;
  representantTelephone?: string;
  // Société
  raisonSociale?: string;
  tvaIntracommunautaire?: string;
  formeJuridique?: string;
  adresseRue?: string;
  adresseCodePostal?: string;
  adresseVille?: string;
  // PDP
  invoiceDirections: InvoiceDirection;
  /** Date d'activation souhaitée (ISO 8601) ; optionnel, null conserve la valeur existante. */
  activeFrom?: string;
}

/** Casse PascalCase alignée sur BCO.CRMClient.Business.Objects.PdpCompanyRegistrationDto — l'API sérialise en PascalCase (NamingStrategy désactivée dans Startup.cs), pas en camelCase. */
export interface PdpCompanyRegistrationDto {
  Id: string;
  CountryCode: string;
  TaxId: string;
  VatId?: string;
  LegalName: string;
  BrandName: string;
  InvoiceDirections: InvoiceDirection;
  Status: PdpCompanyRegistrationStatus;
  ActiveFrom?: string;
  CreatedAtUtc?: string;
  UpdatedAtUtc?: string;
}

/**
 * État d'une demande de vérification KYB (Know Your Business).
 * Aligné sur tCompanyVerificationState (Swagger e-Facture, PdpCompanyVerification).
 * Seul l'état "Approved" débloque l'accès à la configuration e-Facture.
 */
export type KybVerificationState =
  | "Requested"
  | "NotStarted"
  | "InProgress"
  | "Approved"
  | "Failed"
  | "Error"
  | "TimedOut";

/** Regroupement à 3 valeurs de KybVerificationState, pour l'affichage. */
export type KybStatusGroup = "EnCours" | "Validee" | "Refusee";

const KYB_TERMINAL_REJECTION_STATES: KybVerificationState[] = ["Failed", "Error", "TimedOut"];

export function toKybStatusGroup(state: KybVerificationState): KybStatusGroup {
  if (state === "Approved") return "Validee";
  if (KYB_TERMINAL_REJECTION_STATES.includes(state)) return "Refusee";
  return "EnCours";
}

export function isKybTerminalRejection(state: KybVerificationState): boolean {
  return KYB_TERMINAL_REJECTION_STATES.includes(state);
}

/** Casse PascalCase alignée sur BCO.CRMClient.Business.Objects.KybVerificationDto — l'API sérialise en PascalCase (NamingStrategy désactivée dans Startup.cs), pas en camelCase. */
export interface KybVerificationDto {
  Id: string;
  TaxId: string;
  SessionId?: string;
  State: KybVerificationState;
  Link?: string;
  ExpireTimeUtc?: string;
  LastErrorCode?: string;
  LastErrorMessage?: string;
  LastStatusSyncedAtUtc?: string;
  CreatedAtUtc?: string;
  UpdatedAtUtc?: string;
}

export interface KybElectronicAddress {
  electronicAddress: string;
  format: "Siren";
}

export interface KybVerificationCreateRequest {
  taxId?: string;
  electronicAddresses?: KybElectronicAddress[];
  firstName?: string;
  lastName?: string;
  birthDate?: string;
  /**
   * Ne pas renseigner : le serveur impose cette URL, signée, et écrase toute valeur reçue du client.
   * C'est le webhook par lequel l'API e-Facture notifie un changement de statut KYB — il doit pointer
   * vers l'API CRMClient, pas vers une page du navigateur.
   */
  clientCallbackUrl?: string;
}

export * from "./common";
export * from "./e-invoice-client";
export * from "./e-invoice-bank-account";
export * from "./e-invoice-preference";
export * from "./e-invoice-general-preference";
export * from "./e-invoice-tva";
export * from "./e-invoice";
export * from "./e-invoice-company";
export * from "./e-invoice-item";
export * from "./e-invoice-discount";
export * from "./e-invoice-pdp-inbound/e-invoice-pdp-inbound.model";
